import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useGlobalContext } from "../Config";
import { jsPDF } from "jspdf";
import { Dialog } from "primereact/dialog";
import "jspdf-autotable";
import moment from "moment-timezone";
import FileUploadNew from "../components/FileUploadNew";
import * as XLSX from "xlsx";
import { Calendar } from "primereact/calendar";
import { getUserData } from "../utilities/getUserData";
import { formatDate, formatRut } from "../utilities/displayFormat";
import { generateNotaDeCobroPDF } from "../utilities/pdfGenerator";

const Documentos = (props) => {
  const { baseUrl } = useGlobalContext();
  const { headerText } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const { styleProperties } = useGlobalContext();
  const { cobranzasBaseUrl } = useGlobalContext();

  const [empresa, setEmpresa] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  const [anio, setAnio] = useState(moment().year());
  const [mes, setMes] = useState(moment().format("MM"));
  const [documento, setDocumento] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [documentosData, setDocumentosData] = useState([]);
  const userId = sessionStorage.getItem("userId");
  const customHeaderStyle = { backgroundColor: "#e0dddc" };
  const [encodedFile, setEncodedFile] = useState(null);
  const [totalEmitidos, setTotalEmitidos] = useState(0);
  const [documentosRegistrados, setDocumentosRegistrados] = useState(0);
  const [documentosPorRegistrar, setDocumentosPorRegistrar] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [folioTemp, setFolioTemp] = useState({ id: null, folio: null });
  const [detalleVisible, setDetalleVisible] = useState(false);
  const [detalleCobro, setDetalleCobro] = useState([]);
  const [uf, setUf] = useState(0);
  const [estadoDocumento, setEstadoDocumento] = useState("todos");
  const [fechaTemp, setFechaTemp] = useState({});
  const [ufFechaSeleccionada, setUfFechaSeleccionada] = useState(null); // fecha seleccionada
  const [calendarVisible, setCalendarVisible] = useState(false); // control de visibilidad
  const [ufFechaPeriodo, setUfFechaPeriodo] = useState(null);

  const currentYear = new Date().getFullYear();
  const anios = Array.from({ length: currentYear - 2020 + 5 }, (_, i) => ({
    label: String(2020 + i),
    value: 2020 + i,
  }));
  const meses = Array.from({ length: 12 }, (_, i) => {
    const date = new Date(0, i); // Set date to month `i`
    return {
      label:
        date.toLocaleString("es", { month: "long" }).charAt(0).toUpperCase() +
        date.toLocaleString("es", { month: "long" }).slice(1),
      mes: String(i + 1).padStart(2, "0"), // Month number with leading zero
    };
  });

  const user = getUserData();

  useEffect(() => {
    const fetchEmpresas = async () => {
      const endpoint = `${baseUrl}getEmpresasByUsuario?idUsuario=${user.userId}`;

      try {
        const response = await fetch(endpoint, {
          method: "GET",
          credentials: "include",
          redirect: "follow",
        });

        const data = await response.json();

        if (!response.ok || !data.respuesta) {
          throw new Error(data.mensaje || "Error al obtener las empresas.");
        }

        // Mapea las empresas para que tengan label y value
        const empresasReales = data.empresas
          .filter(
            (item) =>
              !String(item.razonSocial || item.nombre || "")
                .toLowerCase()
                .includes("prueba"),
          )
          .map((item) => ({
            label: item.razonSocial || item.nombre || `Empresa ${item.id}`,
            id: item.id,
          }));
        const empresasFetched = [
          { label: "Todas las empresas", id: "TODAS" },
          ...empresasReales,
        ];
        setEmpresas(empresasFetched);
        setEmpresa("TODAS");
      } catch (error) {
        console.error("Error fetching empresas:", error);
      }
    };

    fetchEmpresas();
  }, [baseUrl, userId]);

  useEffect(() => {
    const fetchTiposDocumento = async () => {
      const endpoint = `${baseUrl}getTiposDocumento`;

      try {
        const response = await fetch(endpoint, {
          method: "GET",
          credentials: "include",
          redirect: "follow",
        });

        const data = await response.json();

        if (!response.ok || !data.respuesta) {
          throw new Error(
            data.mensaje || "Error al obtener tipos de documento.",
          );
        }

        const tiposDocumentoFetched = [
          { label: "Ver todo", codigo: 0 },
          ...data.tiposDocumento.map((tipo) => ({
            label: tipo.descripcion,
            codigo: tipo.codigo,
          })),
        ];

        setDocumentos(tiposDocumentoFetched);
        setDocumento(tiposDocumentoFetched[0].codigo);
      } catch (error) {
        console.error("Error fetching tipos de documento:", error);
      }
    };

    fetchTiposDocumento();
  }, [baseUrl]);

  const [importeTotal, setImporteTotal] = useState(0);
  const [documentosEncontrados, setDocumentosEncontrados] = useState(0);
  const resetDocumentData = () => {
    setImporteTotal(0); // Assuming the initial total amount is 0
    setTotalEmitidos(0); // Initial count of issued documents
    setDocumentosRegistrados(0); // Initial count of registered documents
    setDocumentosPorRegistrar(0); // Initial count of documents to be registered
    setDocumentosEncontrados(0); // Initial count of found documents
    setDocumentosData([]); // Assuming documents data is an empty array initially
  };
  const calcularPascua = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return moment({ year, month: month - 1, day });
  };

  const esFeriadoChile = (fecha) => {
    const key = fecha.format("MM-DD");
    const feriadosFijos = new Set([
      "01-01",
      "05-01",
      "05-21",
      "06-21",
      "07-16",
      "08-15",
      "09-18",
      "09-19",
      "10-12",
      "10-31",
      "11-01",
      "12-08",
      "12-25",
    ]);
    if (feriadosFijos.has(key)) return true;
    const viernesSanto = calcularPascua(fecha.year()).subtract(2, "days");
    return fecha.isSame(viernesSanto, "day");
  };

  const primerDiaHabilPeriodo = (year, month) => {
    const fecha = moment(`${year}-${month}-01`, "YYYY-MM-DD");
    while (fecha.isoWeekday() > 5 || esFeriadoChile(fecha)) fecha.add(1, "day");
    return fecha;
  };

  const porcentaje = (valor, total) =>
    total > 0 ? Math.min(100, (valor / total) * 100) : 0;
  const montoUf = (monto) => (uf > 0 ? Number(monto || 0) / uf : 0);
  const irAIndicador = (estado = "todos") => {
    setEstadoDocumento(estado);
    window.setTimeout(
      () =>
        document
          .getElementById("tabla-documentos")
          ?.scrollIntoView({ behavior: "smooth", block: "start" }),
      0,
    );
  };

  const buscarDocumentos = async () => {
    if (
      !empresa ||
      !anio ||
      !mes ||
      documento === null ||
      documento === undefined
    ) {
      alert("Por favor, seleccione todos los campos antes de buscar.");
      return;
    }

    try {
      setIsLoading(true);
      setShowTable(true);

      const idsEmpresa =
        empresa === "TODAS"
          ? empresas
              .filter((item) => item.id !== "TODAS")
              .map((item) => item.id)
          : [empresa];

      const respuestas = await Promise.all(
        idsEmpresa.map(async (idEmpresa) => {
          const endpoint = `${baseUrl}obtenerDocumentos?idEmpresa=${idEmpresa}&anio=${anio}&mes=${mes}&tipoDocumento=${documento}`;
          const response = await fetch(endpoint, {
            method: "GET",
            credentials: "include",
            redirect: "follow",
          });
          const data = await response.json();
          if (!response.ok || data.respuesta !== true) return [];
          return Array.isArray(data.documentos) ? data.documentos : [];
        }),
      );
      const documentosRespuesta = respuestas.flat();

      if (documentosRespuesta.length === 0) {
        alert("No se encontraron documentos para los parámetros ingresados.");
        resetDocumentData();
        return;
      }

      const documentosFetched = documentosRespuesta.map((doc) => {
        const totalIva =
          doc.tipoDocumento.toLowerCase() === "factura afecta"
            ? Math.ceil(Math.ceil(doc.total) * 0.19)
            : 0;

        const fechaDocumento =
          doc.adjuntos && doc.adjuntos.length > 0
            ? doc.adjuntos[0].fecha
            : "Documento no disponible";

        const detallesCobro = doc.detallesCobro.map((detalle) => ({
          codigo: detalle.codigo,
          unidadMedida: detalle.unidadMedida,
          glosa: detalle.glosa,
          cantidad: detalle.cantidad,
          unitario: detalle.unitario,
          lecturaInicial: detalle.lecturaInicial || "No aplica", // Lectura inicial
          lecturaFinal: detalle.lecturaFinal || "No aplica", // Lectura final
          idCobro: detalle.idCobro,
        }));

        return {
          id_documento: doc.idDocumento,
          empresa: doc.descripcionEmpresa,
          rut_empresa: doc.rutEmpresa,
          cliente: doc.aliasCliente || doc.nombreCliente,
          rut_cliente: doc.rutCliente,
          inicio_pago: doc.inicioPago,
          fin_pago: doc.finPago,
          documento: doc.tipoDocumento,
          n_documento: doc.folio,
          fecha_documento: fechaDocumento,
          total_neto: Math.ceil(doc.total),
          total_iva: totalIva,
          total_documento: Math.ceil(doc.total) + totalIva,
          producto:
            [
              ...new Set(
                detallesCobro
                  .map((d) => (d.glosa || "").trim())
                  .filter(Boolean),
              ),
            ].join(" / ") || "Sin producto",
          descripcion_grupo: doc.descripcionGrupo,
          adjuntos: doc.adjuntos || [],
          detalleCobro: detallesCobro,
          fecha_emision: doc.fechaEmision, // Nueva propiedad fecha de emisión
          fecha_vencimiento: doc.fechaVencimiento, // Nueva propiedad fecha de vencimiento
          valor_uf: doc.valorUf,
          fecha_valor_uf: doc.fechaValorUf,
          id_cobranzas_cliente: doc.idCobranzasCliente,
          enviado_cobranzas: doc.enviadoCobranzas === true,
          fecha_envio_cobranzas: doc.fechaEnvioCobranzas,
        };
      });

      const fechaValorUfDocumento =
        documentosFetched.find((doc) => doc.fecha_valor_uf)?.fecha_valor_uf ||
        null;
      setUfFechaPeriodo(fechaValorUfDocumento);

      // Calcular el valor más alto de valor_uf
      const highestUf = documentosFetched.reduce(
        (max, doc) => (doc.valor_uf > max ? doc.valor_uf : max),
        0,
      );

      // Asignar el valor más alto de valor_uf a la variable uf
      setUf(highestUf);

      const totalImporte = documentosFetched.reduce(
        (sum, doc) => sum + doc.total_documento,
        0,
      );

      // **Contar documentos emitidos (con adjunto o notas de cobro)**
      const totalEmitidos = documentosFetched
        .filter((doc) => {
          const esNotaCobro = doc.documento.toLowerCase() === "nota de cobro";
          const tieneAdjunto = doc.adjuntos && doc.adjuntos.length > 0;
          return esNotaCobro || tieneAdjunto;
        })
        .reduce((sum, doc) => sum + doc.total_documento, 0);

      // **Contar documentos registrados**
      const countRegistrados = documentosFetched.filter(
        (doc) =>
          doc.documento.toLowerCase() === "nota de cobro" ||
          (doc.adjuntos && doc.adjuntos.length > 0),
      ).length;

      // **Contar documentos no emitidos (facturas sin adjunto/folio)**
      const countPorRegistrar = documentosFetched.filter(
        (doc) =>
          doc.documento.toLowerCase() !== "nota de cobro" && // notas de cobro no entran aquí
          (!doc.adjuntos || doc.adjuntos.length === 0),
      ).length;

      setImporteTotal(totalImporte);
      setTotalEmitidos(totalEmitidos);
      setDocumentosRegistrados(countRegistrados);
      setDocumentosPorRegistrar(countPorRegistrar);
      setDocumentosEncontrados(documentosFetched.length);
      setDocumentosData(documentosFetched);
    } catch (error) {
      console.error("Error fetching documentos:", error);
      alert("Error: " + error.message);
      resetDocumentData();
    } finally {
      setIsLoading(false);
    }
  };

  const onEditorValueChange = (props, value) => {
    const numericValue = value.replace(/\D/g, "");

    let updatedData = [...documentosData];

    const rowIndex = documentosData.findIndex(
      (doc) => doc.id_documento === props.rowData.id_documento,
    );

    if (updatedData[rowIndex]) {
      updatedData[rowIndex][props.field] = numericValue;
      setDocumentosData(updatedData);
      setFolioTemp({ id: props.rowData.id_documento, folio: numericValue });
    }
  };

  const isCobrarHabilitado = (rowData) => {
    const tipo = (rowData?.documento || "").toLowerCase();
    if (tipo === "nota de cobro") return true;

    const esFactura = tipo === "factura afecta" || tipo === "factura exenta";

    if (esFactura) {
      const tieneFolio = !!rowData?.n_documento;
      const tieneAdjunto =
        Array.isArray(rowData?.adjuntos) && rowData.adjuntos.length > 0;
      return tieneFolio && tieneAdjunto;
    }

    return false;
  };

  const getMontosParaCobranza = (rowData) => {
    const tipo = (rowData?.documento || "").toLowerCase();

    if (tipo === "nota de cobro") {
      const detalles = Array.isArray(rowData?.detalleCobro)
        ? rowData.detalleCobro
        : [];
      const total = detalles.reduce(
        (acc, d) => acc + Number(d.cantidad || 0) * Number(d.unitario || 0),
        0,
      );
      return {
        neto: total,
        deuda: total,
      };
    }

    // Facturas
    return {
      neto: Number(rowData?.total_neto || 0),
      deuda: Number(rowData?.total_documento || 0),
    };
  };

  const mapTipoDocumentoCobranzas = (rowData) => {
    const t = (rowData?.documento || "").toLowerCase();
    if (t === "factura afecta") return 1;
    if (t === "factura exenta") return 2;
    if (t === "nota de cobro") return 5;
    return 0;
  };

  const toISOChile = (yyyy_mm_dd) => {
    if (!yyyy_mm_dd) return null;
    const m = moment.tz(yyyy_mm_dd, "YYYY-MM-DD", "America/Santiago");
    return m.isValid() ? m.toDate().toISOString() : null;
  };

  const cobrarDocumento = async (rowData) => {
    if (isLoading || rowData?.enviado_cobranzas) return;
    try {
      const tipo = (rowData?.documento || "").toLowerCase();
      const tieneAdjunto =
        Array.isArray(rowData?.adjuntos) && rowData.adjuntos.length > 0;
      if (
        (tipo === "factura afecta" || tipo === "factura exenta") &&
        (!rowData?.n_documento || !tieneAdjunto)
      ) {
        alert(
          "Para facturas, debes ingresar el folio y adjuntar el documento antes de cobrar.",
        );
        return;
      }

      setIsLoading(true);
      const resp = await fetch(
        `${baseUrl}enviarDocumentoCobranzas?idDocumento=${rowData.id_documento}`,
        {
          method: "POST",
          credentials: "include",
          redirect: "follow",
        },
      );
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || data?.respuesta === false)
        throw new Error(
          data?.mensaje || `Error ${resp.status} al enviar a cobranzas`,
        );

      setDocumentosData((actuales) =>
        actuales.map((doc) =>
          doc.id_documento === rowData.id_documento
            ? {
                ...doc,
                enviado_cobranzas: true,
                fecha_envio_cobranzas:
                  data.fechaEnvio || new Date().toISOString(),
              }
            : doc,
        ),
      );
      alert(
        data?.mensaje ||
          "Documento enviado al servicio de cobranzas correctamente.",
      );
    } catch (err) {
      console.error("Cobranza error:", err);
      alert(`No se pudo completar la cobranza: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const actualizarFolioDocumento = async (rowData) => {
    if (folioTemp.id && folioTemp.folio !== null) {
      if (rowData.documento.toLowerCase() === "nota de cobro") return;

      const isConfirmed = window.confirm(
        `¿Es correcto el número ingresado (${folioTemp.folio})?`,
      );

      if (!isConfirmed) return;

      try {
        const endpoint = `${baseUrl}actualizarFolio?id_documento=${folioTemp.id}&folio=${folioTemp.folio}`;
        const response = await fetch(endpoint, {
          method: "POST",
          credentials: "include",
          redirect: "follow",
        });

        const data = await response.json();

        if (!response.ok || !data.respuesta) {
          throw new Error(data.mensaje || "Error al actualizar el folio.");
        }

        alert("Folio actualizado correctamente");
        buscarDocumentos();
      } catch (error) {
        console.error("Error actualizando el folio:", error);
        alert("Error: " + error.message);
      }
    }
  };

  const obtenerTipoCambioUf = async (fecha) => {
    const fechaFormato = moment(fecha).format("YYYY-MM-DD");
    try {
      const response = await fetch(
        `${baseUrl}obtenerTipoCambio?fecha=${fechaFormato}&origen=CLP&destino=UF`,
        {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        },
      );

      const data = await response.json();

      if (data.respuesta) {
        setUf(data.valor); // Actualiza el valor UF
        setUfFechaPeriodo(fecha);
      } else {
        alert(data.mensaje || "No se pudo obtener el tipo de cambio.");
      }
    } catch (error) {
      console.error("Error al obtener tipo de cambio:", error);
      alert("Error al obtener tipo de cambio.");
    }
  };

  const confirmarYActualizar = async (rowData) => {
    if (rowData.documento.toLowerCase() === "nota de cobro") return; // No aplicar lógica para Notas de Cobro

    const isConfirmed = window.confirm(
      `¿Es correcto el número ingresado (${folioTemp.folio})?`,
    );

    if (!isConfirmed) {
      // Si el usuario no confirma, no hacemos nada
      alert("Actualización cancelada.");
      return;
    }

    try {
      // Actualizar folio en el sistema principal
      const endpoint = `${baseUrl}actualizarFolio?id_documento=${folioTemp.id}&folio=${folioTemp.folio}`;
      const response = await fetch(endpoint, {
        method: "POST",
        credentials: "include",
        redirect: "follow",
      });

      const data = await response.json();

      if (!response.ok || !data.respuesta) {
        throw new Error(data.mensaje || "Error al actualizar el folio.");
      }

      alert("Folio actualizado correctamente en el sistema principal.");

      // Llamar al servicio de cobranza
      const cobranzaPayload = {
        cliente: rowData.rut_cliente, // RUT del cliente
        deuda: rowData.total_documento, // Total del documento
        fechaEmision: rowData.fecha_emision, // Fecha de emisión
        fechaVencimiento: rowData.fecha_vencimiento, // Fecha de vencimiento
        folio: rowData.n_documento, // Folio actualizado
        neto: rowData.total_neto, // Total neto
        tipoDocumento:
          rowData.documento.toLowerCase() === "factura afecta" ? 1 : 2, // Tipo de documento (1 para afecta, 2 para exenta)
      };

      const cobranzaEndpoint = `${baseUrl}cobranzaService/agregarDocumento`;
      const cobranzaResponse = await fetch(cobranzaEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        redirect: "follow",
        body: JSON.stringify(cobranzaPayload),
      });

      const cobranzaData = await cobranzaResponse.json();

      if (!cobranzaResponse.ok || !cobranzaData.respuesta) {
        throw new Error(cobranzaData.mensaje || "Error al procesar cobranza.");
      }

      alert("Documento enviado al servicio de cobranza correctamente.");
    } catch (error) {
      console.error("Error al actualizar el folio o procesar cobranza:", error);
      alert("Error: " + error.message);
    }
  };

  const actualizarFechaDocumento = async (idAdjunto, nuevaFecha) => {
    if (!idAdjunto || !nuevaFecha) return;

    const fechaFormateada = moment(nuevaFecha).format("YYYY-MM-DD HH:mm:ss");

    try {
      const endpoint = `${baseUrl}actualizarFechaAdjunto?idAdjunto=${idAdjunto}&fecha=${fechaFormateada}`;
      const response = await fetch(endpoint, {
        method: "POST",
        credentials: "include",
        redirect: "follow",
      });

      const data = await response.json();

      if (!response.ok || !data.respuesta) {
        throw new Error(data.mensaje || "Error al actualizar la fecha.");
      }

      alert("Fecha actualizada correctamente");
      buscarDocumentos(); // Refrescar la tabla
    } catch (error) {
      console.error("Error actualizando la fecha:", error);
      alert("Error: " + error.message);
    }
  };

  /////////////////////////////////////////////// LOGICA PARA GUARDAR LOS DOCUMENTOS SUBIDOS A LA APP. ///////////////////////////////////////////////

  // const documentoSubidoTemplate = (rowData) => {
  //   const tieneAdjunto = rowData.adjuntos && rowData.adjuntos.length > 0;
  //   const tipoDocumento = rowData.documento.toLowerCase();
  //   const uploadButtonRef = useRef(null);
  //   const downloadButtonRef = useRef(null);
  //   const pdfButtonRef = useRef(null);

  //   if (tipoDocumento === "factura afecta" || tipoDocumento === "factura exenta") {
  //     if (!tieneAdjunto) {
  //       return (
  //         <>
  //           <FileUpload
  //             mode="basic"
  //             chooseOptions={{
  //               className:
  //                 "p-button-rounded p-button-primary p-button-icon-only p-button-lg custom-file-upload",
  //               icon: "pi pi-upload",
  //               label: 'Upload Document',
  //             }}
  //             multiple={false}
  //             customUpload
  //             uploadHandler={(e) => handleFileUpload(e, rowData)}
  //             disabled={isUploading}
  //             ref={uploadButtonRef}
  //           />
  //           <Tooltip
  //             target={uploadButtonRef.current?.element}
  //             content="Click to upload the document, then click again to confirm."
  //           />
  //         </>
  //       );
  //     } else {
  //       const adjunto = rowData.adjuntos[0];
  //       return (
  //         <>
  //           <Button
  //             icon="pi pi-download"
  //             className="p-button-rounded p-button-success"
  //             onClick={() => bajarArchivo(rowData.id_documento, adjunto.nombre)}
  //             disabled={isUploading}
  //             ref={downloadButtonRef}
  //           />
  //           <Tooltip
  //             target={downloadButtonRef.current?.element}
  //             content="Click to download the attached document."
  //           />
  //         </>
  //       );
  //     }
  //   } else if (tipoDocumento === "nota de cobro") {
  //     return (
  //       <>
  //         <Button
  //           icon="pi pi-file-pdf"
  //           className="p-button-rounded p-button-warning"
  //           onClick={() => exportToPDF(rowData)}
  //           disabled={isUploading}
  //           ref={pdfButtonRef}
  //         />
  //         <Tooltip
  //           target={pdfButtonRef.current?.element}
  //           content="Click to generate a PDF for this document."
  //         />
  //       </>
  //     );
  //   }

  //   return null;
  // };

  const detalleCobroTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-exclamation-circle"
        className="p-rounded-icon-only p-button-rounded p-button-info"
        onClick={() => verDetalle(rowData.detalleCobro)}
        style={{ marginRight: "3px" }}
      />
    );
  };

  const verDetalle = (rowData) => {
    setDetalleCobro(rowData);
    setDetalleVisible(true);
  };

  const handleFileUpload = async (event, rowData) => {
    if (!isSaved) {
    }
    const file = event.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const base64Data = btoa(e.target.result);

        const contentType = file.type;
        const fileName = file.name;
        const fileSize = file.size;
        const usuario = sessionStorage.getItem("username");

        setEncodedFile(base64Data);
        subirArchivo(
          JSON.stringify({
            contentType: contentType,
            fileName: fileName,
            base64: base64Data,
            fileSize: fileSize,
            idDocumento: rowData.id_documento,
            usuario: usuario,
          }),
        );
      };

      reader.readAsBinaryString(file);
    }
  };

  ////////////////////////////////// Gestion de archivos (subir, descargar documentos y exportar excel) //////////////////////////////////

  const subirArchivo = async (archivo) => {
    const endpoint = baseUrl + "adjuntarArchivoDocumento";
    try {
      setIsUploading(true);
      const data = await fetch(endpoint, {
        method: "POST",
        credentials: "include",
        redirect: "follow",
        body: archivo,
        headers: { "Content-Type": "application/json" },
      }).then((res) => res.json());

      if (data.mensaje !== "OK") {
        throw new Error("Failed to create the request");
      }

      if (data.respuesta) {
        alert("Archivo subido exitosamente");

        setFolioTemp({ id: null, folio: null });
        await buscarDocumentos();
      } else {
        alert("Hubo un problema al subir el archivo");
      }
    } catch (error) {
      console.error("Error:", error.message);
    } finally {
      setIsUploading(false);
    }
  };

  const bajarArchivo = async (idDocumento, nombreArchivo) => {
    setLoading(true);
    try {
      const response = await fetch(
        baseUrl + "descargar/adjunto/documento?id=" + idDocumento,
        {
          method: "GET",
          credentials: "include",
          redirect: "follow",
          headers: { "Content-Type": "application/json" },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to download file. Status: ${response.status}`);
      }
      const blob = await response.blob(); // Get the response body as Blob

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      const fileName =
        response.headers.get("Content-Disposition")?.split("=")[1] ||
        nombreArchivo;

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
    setLoading(false);
  };

  const exportarExcel = () => {
    if (!documentosFiltrados || documentosFiltrados.length === 0) {
      alert("No hay datos para exportar.");
      return;
    }

    const data = documentosFiltrados.map((doc) => ({
      "ID Documento": doc.id_documento,
      Cliente: doc.cliente,
      "RUT Cliente": formatRut(doc.rut_cliente),
      Asignación: doc.descripcion_grupo,
      Empresa: doc.empresa,
      "Tipo Documento": doc.documento,
      "N° Documento": doc.n_documento,
      "Fecha Documento": doc.fecha_documento,
      "Total Neto": doc.total_neto,
      "Total IVA": doc.total_iva,
      "Total Documento": doc.total_documento,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data, { origin: "A2" }); // empieza en A2 para dejar espacio al título
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Documentos");

    // Crear título
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [[`Documentos del Periodo ${mes}-${anio}`], []],
      { origin: "A1" },
    );

    // Estilo moneda en las columnas J (Total Neto), K (Total IVA), L (Total Documento)
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = 2; R <= range.e.r; ++R) {
      ["I", "J", "K"].forEach((col) => {
        const cell = worksheet[`${col}${R + 1}`]; // +1 por el encabezado
        if (cell && typeof cell.v === "number") {
          cell.z = '"$"#,##0';
        }
      });
    }

    // Establecer ancho de columnas (opcional)
    worksheet["!cols"] = [
      { wch: 12 }, // ID
      { wch: 30 }, // Cliente
      { wch: 15 }, // RUT
      { wch: 20 }, // Asignación
      { wch: 25 }, // Empresa
      { wch: 20 }, // Tipo Doc
      { wch: 15 }, // N° Doc
      { wch: 18 }, // Fecha
      { wch: 15 }, // Neto
      { wch: 15 }, // IVA
      { wch: 20 }, // Total
    ];

    // Descargar archivo
    const nombreArchivo = `documentos_${mes}-${anio}.xlsx`;
    XLSX.writeFile(workbook, nombreArchivo);
  };

  ////////////////////////////////// Creacion de PDF para las notas de cobro //////////////////////////////////

  async function loadLogo() {
    const logoUrlRemote = `${window.location.origin}/logoCBQ.png`;
    const logoUrlLocal = "/logoCBQ.png"; // Asegúrate de que está en /public

    async function fetchImage(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Error al cargar la imagen");
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.warn(`No se pudo cargar la imagen desde ${url}:`, error);
        throw error;
      }
    }

    try {
      return await fetchImage(logoUrlRemote);
    } catch {
      return await fetchImage(logoUrlLocal);
    }
  }

  const verNotaCobro = async (rowData) => {
    // Las notas de cobro se regeneran con la plantilla vigente.
    exportToPDF(rowData);
  };

  const exportToPDF = (documento) => {
    const blob = generateNotaDeCobroPDF(
      baseUrl,
      documento,
      formatNumber,
      formatNumberUf,
      formatDate,
      mes,
      anio,
    );
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  };

  const formatNumber = (number) => {
    if (typeof number !== "number") return number;
    number = Math.ceil(number);
    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  const formatNumberUf = (number) => {
    if (typeof number !== "number") return number;
    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  };

  const [globalFilter, setGlobalFilter] = useState("");

  const textoBusqueda = globalFilter.trim().toLowerCase();
  const documentosClienteFiltrados = documentosData.filter((doc) => {
    if (!textoBusqueda) return true;
    const cliente = String(doc.cliente || "").toLowerCase();
    const producto = String(doc.producto || "").toLowerCase();
    return cliente.includes(textoBusqueda) || producto.includes(textoBusqueda);
  });

  const metricasVisibles = documentosClienteFiltrados.reduce(
    (acc, doc) => {
      const esNotaCobro =
        String(doc.documento || "").toLowerCase() === "nota de cobro";
      const emitido =
        esNotaCobro || (Array.isArray(doc.adjuntos) && doc.adjuntos.length > 0);
      const total = Number(doc.total_documento || 0);
      acc.importe += total;
      if (emitido) {
        acc.emitidos += total;
        acc.registrados += 1;
      } else if (!esNotaCobro) acc.porRegistrar += 1;
      acc.encontrados += 1;
      return acc;
    },
    {
      importe: 0,
      emitidos: 0,
      registrados: 0,
      porRegistrar: 0,
      encontrados: 0,
    },
  );

  const documentosFiltrados = documentosClienteFiltrados.filter((doc) => {
    const esNotaCobro =
      String(doc.documento || "").toLowerCase() === "nota de cobro";
    if (estadoDocumento === "emitidos")
      return esNotaCobro || (doc.adjuntos && doc.adjuntos.length > 0);
    if (estadoDocumento === "noEmitidos")
      return !esNotaCobro && (!doc.adjuntos || doc.adjuntos.length === 0);
    return true;
  });

  return (
    <div>
      <h3>Documentos</h3>
      <div className="flex flex-column align-items-center justify-content-center mb-5 bg-surface-50">
        <div className="card shadow-4 surface-card border-round-md w-full max-w-lg">
          <h4 className="text-center text-primary mb-4">Buscar Documentos</h4>

          <div className="grid formgrid">
            <div className="field col-12 md:col-6 mb-4">
              <label
                htmlFor="empresa"
                className="block font-semibold mb-1 text-gray-600"
              >
                Empresa
              </label>
              <Dropdown
                inputId="empresa"
                aria-label="Seleccionar empresa"
                value={empresa}
                options={empresas.map((option) => ({
                  ...option,
                  label: option.label.toUpperCase(),
                }))}
                onChange={(e) => setEmpresa(e.value)}
                optionLabel="label"
                optionValue="id"
                placeholder="Seleccione una empresa"
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="field col-12 md:col-6 mb-4">
              <label
                htmlFor="documento"
                className="block font-semibold mb-1 text-gray-600"
              >
                Tipo de Documento
              </label>
              <Dropdown
                inputId="documento"
                aria-label="Seleccionar tipo de documento"
                value={documento}
                options={documentos.map((option) => ({
                  ...option,
                  label: option.label.toUpperCase(),
                }))}
                onChange={(e) => setDocumento(e.value)}
                optionLabel="label"
                optionValue="codigo"
                placeholder="Seleccione un documento"
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="field col-12 md:col-6 mb-4">
              <label
                htmlFor="mes"
                className="block font-semibold mb-1 text-gray-600"
              >
                Mes
              </label>
              <Dropdown
                inputId="mes"
                aria-label="Seleccionar mes"
                value={mes}
                options={meses.map((option) => ({
                  ...option,
                  label: option.label.toUpperCase(),
                }))}
                onChange={(e) => setMes(e.value)}
                optionLabel="label"
                optionValue="mes"
                placeholder="Seleccione un mes"
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="field col-12 md:col-6 mb-4">
              <label
                htmlFor="anio"
                className="block font-semibold mb-1 text-gray-600"
              >
                Año
              </label>
              <Dropdown
                inputId="anio"
                aria-label="Seleccionar año"
                value={anio}
                options={anios.map((option) => ({
                  ...option,
                  label: option.label.toUpperCase(),
                }))}
                onChange={(e) => setAnio(e.value)}
                placeholder="Seleccione un año"
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>

            <div className="col-12 text-center">
              <Button
                label="Buscar Documentos"
                aria-label="Buscar documentos"
                onClick={buscarDocumentos}
                className="p-button-raised p-button-primary w-full md:w-auto px-6 py-2 text-lg font-medium shadow-lg transition duration-150 ease-in-out "
                icon="pi pi-search"
              />
            </div>
          </div>
        </div>
      </div>

      {showTable && (
        <div className="p-fluid mt-3 mb-3" style={{ position: "relative" }}>
          <style>
            {`
        /* Card Container Grid */
        .card-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr); /* 3 columns for desktop and tablet */
          gap: 1rem;
          align-items: stretch;
        }

        /* Mobile layout: 2x2x2 grid */
        @media (max-width: 768px) {
          .card-container {
            grid-template-columns: repeat(2, 1fr); /* 2 columns for mobile */
          }
        }

        /* Individual Card Styling */
        .responsive-card {
          background-color: #ffffff;
          padding: 1.5rem;
          border-radius: 0.5rem;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          border-top: 4px solid #007bff; /* Primary border color */
          min-height: 150px;
        }

        /* Color accents for each card */
        .responsive-card:nth-child(1) { border-top-color: #28a745; } /* Green */
        .responsive-card:nth-child(2) { border-top-color: #007bff; } /* Blue */
        .responsive-card:nth-child(3) { border-top-color: #ffc107; } /* Yellow */
        .responsive-card:nth-child(4) { border-top-color: #dc3545; } /* Red */
        .responsive-card:nth-child(5) { border-top-color: #17a2b8; } /* Teal */
        .responsive-card:nth-child(6) { border-top-color: #6f42c1; } /* Purple */

        /* Hover Effect */
        .responsive-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
        }

        .responsive-card h1 {
          font-size: 1.4rem;
          margin: 0;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .responsive-card span.label {
          font-weight: 600;
          color: #4a5568;
          font-size: 0.9rem;
          margin-bottom: 0.5rem;
        }

        .responsive-card span.description {
          font-size: 0.875rem;
          color: #666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .responsive-card .value {
          font-size: 1.2rem;
          color: #333;
        }

        /* Icon Styling */
        .icon {
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }

        /* Loading Overlay */
        .loading-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.5rem;
          z-index: 1;
        }

        /* Spinner Styling */
        .spinner {
          border: 4px solid rgba(0, 0, 0, 0.1);
          border-top: 4px solid #007bff;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
          </style>

          {/* Loading Overlay */}
          {isLoading && (
            <div className="loading-overlay">
              <div className="spinner"></div>
            </div>
          )}

          {/* Card Container */}
          <div className="card-container">
            {/* Cards */}
            <div
              className="responsive-card"
              onClick={() => setCalendarVisible(true)}
              style={{ cursor: "pointer" }}
            >
              <i className="icon pi pi-dollar"></i>
              <span className="label">Valor UF:</span>
              <h1 className="value">${formatNumberUf(uf)}</h1>
              <span className="description">
                {ufFechaPeriodo
                  ? `Valor al ${moment(ufFechaPeriodo, [
                      "DD-MM-YYYY",
                      "YYYY-MM-DD",
                    ]).format("DD-MM-YYYY")}`
                  : "Fecha UF no disponible"}
              </span>
            </div>
            {calendarVisible && (
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 9999,
                  backgroundColor: "white",
                  padding: "2rem",
                  borderRadius: "1rem",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                  width: "400px",
                }}
              >
                <h4 className="mb-3 text-center">Selecciona una fecha</h4>
                <Calendar
                  value={ufFechaSeleccionada}
                  onChange={(e) => setUfFechaSeleccionada(e.value)}
                  inline
                  maxDate={new Date()}
                  dateFormat="dd-mm-yy"
                />
                <div className="mt-3 flex gap-2 justify-content-center">
                  <Button
                    label="Buscar UF"
                    icon="pi pi-search"
                    onClick={() => {
                      if (!ufFechaSeleccionada) {
                        alert("Selecciona una fecha válida");
                        return;
                      }
                      obtenerTipoCambioUf(ufFechaSeleccionada);
                      setCalendarVisible(false);
                    }}
                    className="p-button-success"
                  />
                  <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={() => setCalendarVisible(false)}
                    className="p-button-danger"
                  />
                </div>
              </div>
            )}

            <div
              className="responsive-card"
              role="button"
              tabIndex={0}
              onClick={() => irAIndicador("todos")}
            >
              <i className="icon pi pi-file"></i>
              <span className="label">Recaudación total a emitir:</span>
              <h1 className="value">
                ${formatNumber(metricasVisibles.importe)}
              </h1>
              <span className="description">
                UF {formatNumberUf(montoUf(metricasVisibles.importe))} · 100%
              </span>
            </div>

            <div
              className="responsive-card"
              role="button"
              tabIndex={0}
              onClick={() => irAIndicador("emitidos")}
            >
              <i className="icon pi pi-send"></i>
              <span className="label">Recaudación emitida:</span>
              <h1 className="value">
                ${formatNumber(metricasVisibles.emitidos)}
              </h1>
              <span className="description">
                UF {formatNumberUf(montoUf(metricasVisibles.emitidos))} ·{" "}
                {formatNumberUf(
                  porcentaje(
                    metricasVisibles.emitidos,
                    metricasVisibles.importe,
                  ),
                )}
                %
              </span>
            </div>

            <div
              className="responsive-card"
              role="button"
              tabIndex={0}
              onClick={() => irAIndicador("todos")}
            >
              <i className="icon pi pi-search"></i>
              <span className="label">Total de documentos a emitir</span>
              <h1 className="value">{metricasVisibles.encontrados}</h1>
              <span className="description">100%</span>
            </div>

            <div
              className="responsive-card"
              role="button"
              tabIndex={0}
              onClick={() => irAIndicador("emitidos")}
            >
              <i className="icon pi pi-check-circle"></i>
              <span className="label">Documentos Emitidos</span>
              <h1 className="value">{metricasVisibles.registrados}</h1>
              <span className="description">
                {formatNumberUf(
                  porcentaje(
                    metricasVisibles.registrados,
                    metricasVisibles.encontrados,
                  ),
                )}
                %
              </span>
            </div>

            <div
              className="responsive-card"
              role="button"
              tabIndex={0}
              onClick={() => irAIndicador("noEmitidos")}
            >
              <i className="icon pi pi-exclamation-triangle"></i>
              <span className="label">Documentos por Emitir</span>
              <h1 className="value">{metricasVisibles.porRegistrar}</h1>
              <span className="description">
                {formatNumberUf(
                  porcentaje(
                    metricasVisibles.porRegistrar,
                    metricasVisibles.encontrados,
                  ),
                )}
                %
              </span>
            </div>
          </div>
        </div>
      )}

      {showTable && (
        <div className="p-mt-3">
          <style>
            {`
        /* Wrapper for rounded table shape */
        .table-wrapper {
          border-radius: 0.5rem;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
        }

        /* Table Styling */
        .p-datatable {
          border: none;
          border-radius: 0.5rem;
        }
        .p-datatable .p-datatable-thead > tr > th {
          background-color: #e3f2fd; /* Light blue header */
          font-weight: 600;
          text-align: center;
          border-bottom: none;
        }

        .p-datatable .p-datatable-tbody > tr {
          transition: background-color 0.2s ease;
        }

        /* Row hover effect */
        .p-datatable .p-datatable-tbody > tr:hover {
          background-color: #f1f5f9;
        }

        /* Alternate row colors */
        .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
          background-color: #ffffff;
        }
        .p-datatable .p-datatable-tbody > tr:nth-child(even) {
          background-color: #f9fafb;
        }

        /* Centering text */
        .p-datatable .p-column-header-content {
          justify-content: center;
        }

        /* Table cell padding and rounding */
        .p-datatable .p-datatable-tbody > tr > td {
          padding: 1rem;
          border-radius: 0.25rem;
        }

        /* Action Column Icons */
        .action-icons {
          display: flex;
          gap: 0.5rem;
        }

        /* Icon Styling */
        .icon {
          font-size: 1.5rem;
          color: #007bff;
          cursor: pointer;
          transition: color 0.2s ease;
        }
        .icon:hover {
          color: #0056b3; /* Darker blue on hover */
        }

        /* Responsive */
        .table-wrapper {
          overflow-x: auto;
        }

        /* Custom loading spinner */
        .custom-spinner {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          width: 100%;
          font-size: 2rem;
          color: #007bff;
        }
      `}
          </style>

          {/* Global Filter Input */}
          <div
            className="inputgroup"
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "stretch", // asegura que todos estén alineados verticalmente
              flexWrap: "wrap", // para que en pantallas pequeñas se acomoden uno abajo del otro
              marginBottom: "1rem",
            }}
          >
            <InputText
              placeholder="Buscar por cliente o producto"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              style={{
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                boxShadow: "0 2px 8px rgba(0, 123, 255, 0.2)",
                fontSize: "1rem",
                flex: "1",
                maxWidth: "200px",
                height: "42px",
              }}
            />
            <Dropdown
              id="estadoDocumento"
              value={estadoDocumento}
              options={[
                { label: "Todos", value: "todos" },
                { label: "Emitidos", value: "emitidos" },
                { label: "No Emitidos", value: "noEmitidos" },
              ]}
              style={{
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                boxShadow: "0 2px 8px rgba(0, 123, 255, 0.2)",
                fontSize: "1rem",
                flex: "1",
                maxWidth: "200px",
                height: "42px",
              }}
              onChange={(e) => setEstadoDocumento(e.value)}
              placeholder="Seleccione un estado"
              className="p-0"
            />
            <Button
              style={{
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                boxShadow: "0 2px 8px rgba(0, 123, 255, 0.2)",
                fontSize: "1rem",
                flex: "1",
                maxWidth: "150px",
                height: "42px",
              }}
              label="Exportar a Excel"
              icon="pi pi-file-excel"
              className="p-button-success mb-3"
              onClick={exportarExcel}
            />
          </div>

          {/* Wrapper for Responsive Scroll */}
          <div className="table-wrapper" id="tabla-documentos">
            <DataTable
              className="p-datatable-gridlines"
              value={documentosFiltrados}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 20, 50]}
              loading={isLoading}
              emptyMessage="No se encontraron documentos"
              scrollable
              scrollHeight="750px" // Define un alto para que se active el scroll
              scrollDirection="vertical" // Habilita scroll vertical
            >
              <Column field="producto" header="Producto" sortable />
              <Column field="cliente" header="Cliente" sortable />
              <Column field="descripcion_grupo" header="Asignación" sortable />
              <Column field="empresa" header="Empresa" sortable />
              <Column
                field="rut_cliente"
                header="RUT Cliente"
                sortable
                body={(rowData) => formatRut(rowData.rut_cliente)}
              />
              <Column field="documento" header="Documento" sortable />
              <Column
                field="n_documento"
                sortable
                header="N° Documento"
                body={(rowData) => (
                  <InputText
                    value={rowData.n_documento || ""}
                    onChange={(e) =>
                      onEditorValueChange(
                        { rowData, field: "n_documento" },
                        e.target.value,
                      )
                    }
                    onBlur={() => actualizarFolioDocumento(rowData)}
                    disabled={
                      rowData.documento.toLowerCase() === "nota de cobro"
                    }
                  />
                )}
              />
              <Column
                field="fecha_documento"
                header="Fecha Documento"
                sortable
                body={(rowData) => {
                  const tieneAdjunto =
                    rowData.adjuntos && rowData.adjuntos.length > 0;
                  const idAdjunto = tieneAdjunto
                    ? rowData.adjuntos[0].id
                    : null;

                  if (!tieneAdjunto || !rowData.fecha_documento) {
                    return "Documento no disponible";
                  }

                  const fechaActual = fechaTemp[idAdjunto]
                    ? fechaTemp[idAdjunto]
                    : new Date(rowData.fecha_documento);

                  return (
                    <Calendar
                      value={fechaActual}
                      showIcon
                      dateFormat="dd-mm-yy"
                      onChange={(e) => {
                        const nuevaFecha = e.value;
                        setFechaTemp((prev) => ({
                          ...prev,
                          [idAdjunto]: nuevaFecha,
                        }));
                      }}
                      onHide={() => {
                        const nuevaFecha = fechaTemp[idAdjunto];
                        if (!nuevaFecha) return;

                        const confirmacion = window.confirm(
                          `¿Está seguro de actualizar la fecha a ${moment(
                            nuevaFecha,
                          ).format("DD-MM-YYYY")}?`,
                        );

                        if (confirmacion) {
                          actualizarFechaDocumento(idAdjunto, nuevaFecha);
                        }
                      }}
                    />
                  );
                }}
              />

              <Column
                field="total_neto"
                header="Total Neto"
                sortable
                body={(rowData) => formatNumber(rowData.total_neto)}
              />
              <Column
                field="total_iva"
                header="Total IVA"
                sortable
                body={(rowData) => formatNumber(rowData.total_iva)}
              />
              <Column
                field="total_documento"
                header="Total Documento"
                sortable
                body={(rowData) => formatNumber(rowData.total_documento)}
              />
              <Column
                field="adjuntos"
                header="Acción"
                body={(rowData) => (
                  <div className="action-icons">
                    {detalleCobroTemplate(rowData)}

                    <FileUploadNew
                      rowData={rowData}
                      handleFileUpload={handleFileUpload}
                      bajarArchivo={bajarArchivo}
                      exportToPDF={verNotaCobro}
                      isUploading={isUploading}
                    />

                    <Button
                      label={rowData.enviado_cobranzas ? "Enviado" : "Cobrar"}
                      icon="pi pi-credit-card"
                      className="p-button-rounded p-button-help"
                      onClick={() => cobrarDocumento(rowData)}
                      disabled={
                        isLoading ||
                        rowData.enviado_cobranzas ||
                        !isCobrarHabilitado(rowData)
                      }
                      title={
                        rowData.enviado_cobranzas
                          ? "Este documento ya fue enviado a cobranzas"
                          : isCobrarHabilitado(rowData)
                          ? "Iniciar proceso de cobranza"
                          : "Para facturas: requiere folio y documento adjunto"
                      }
                    />
                  </div>
                )}
              />
            </DataTable>
          </div>
        </div>
      )}

      <Dialog
        header="Detalle del Cobro"
        visible={detalleVisible}
        style={{ width: "50vw" }}
        onHide={() => setDetalleVisible(false)}
      >
        <DataTable value={detalleCobro}>
          <Column field="glosa" header="Descripción Item" />
          <Column field="cantidad" header="Cantidad" />
          <Column field="unidadMedida" header="Unidad Medida" />
          <Column
            field="unitario"
            header="Valor Unitario"
            body={(rowData) => formatNumber(rowData.unitario)}
          />
          <Column field="lecturaInicial" header="Lectura Inicial" />
          <Column field="lecturaFinal" header="Lectura Final" />
        </DataTable>
      </Dialog>
    </div>
  );
};

export default Documentos;
